import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { OutwriteApi } from '../services/OutwriteService';
import OutwriteLlmModelSelect from './OutwriteLlmModelSelect';

/** Cloud agent runs can take several minutes; keep axios aligned with nginx. */
const ANSWER_TIMEOUT_MS = 15 * 60 * 1000;

/**
 * Outwrite LLM PoC: multiline prompt → POST /outwrite/answer → show text reply.
 */
export default function OutwriteLlm() {
  const [prompt, setPrompt] = useState('');
  const [answer, setAnswer] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSend = () => {
    const text = prompt.trim();
    if (!text || loading) {
      return;
    }
    setLoading(true);
    setAnswer('');
    OutwriteApi.answer(text, ANSWER_TIMEOUT_MS)
      .then((data) => {
        setAnswer(data?.text ?? '');
      })
      .catch(() => {
        // Global error modal via axios interceptor / errorBus
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Box sx={{ p: 3, maxWidth: 960, mx: 'auto' }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        justifyContent="space-between"
        sx={{ mb: 2 }}
      >
        <Box>
          <Typography variant="h5" component="h1">
            LLM
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Send a prompt via the configured LlmClient (model selectable at runtime).
          </Typography>
        </Box>
        <OutwriteLlmModelSelect disabled={loading} />
      </Stack>

      <Stack spacing={2}>
        <TextField
          label="Prompt"
          value={prompt}
          onChange={(event) => setPrompt(event.target.value)}
          fullWidth
          multiline
          minRows={12}
          disabled={loading}
        />
        <Box>
          <Button
            variant="contained"
            onClick={handleSend}
            disabled={loading || !prompt.trim()}
            startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
          >
            {loading ? 'Waiting…' : 'SEND'}
          </Button>
        </Box>
        <TextField
          label="Answer"
          value={answer}
          fullWidth
          multiline
          minRows={8}
          slotProps={{ input: { readOnly: true } }}
        />
      </Stack>
    </Box>
  );
}
